import { createFileRoute } from '@tanstack/react-router';

import {
  bankAccountMedContestScreen,
  accountMedSearch,
  loadBankAccountMessages,
  loadBankAccountScreens,
} from '@/modules/bank-account/route';
import { lazyScreen } from '@/shared/screen';

export const Route = createFileRoute(
  '/_app/contas-digitais/contas/$bankAccountId/pix/pix-med/contestar',
)({
  validateSearch: accountMedSearch,
  staticData: { screen: bankAccountMedContestScreen },
  loader: loadBankAccountMessages,
  component: lazyScreen(loadBankAccountScreens, 'BankAccountMedContestScreen'),
});
